import { useDispatch, useSelector } from 'react-redux';
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
    TextField,
    Typography,
} from '@material-ui/core';
import { UPDATE_AWARDING_RULE } from '../../../store/awardingRule';
import './InformationSection.scss';
import '../../../SetupList/SetupEdit/SetupEdit.scss';

const InputTitle = (props) => (
    <Typography
        component="p"
        className="input-label"
        {...props}
    >
        {props.children}
    </Typography>
);

const InputDisclaimer = (props) => (
    <p {...props}>
        <small className="input-disclaimer">
            {props.children}
        </small>
    </p>
);

/**
 * @param {{validationErrors: {[Key: string] : boolean}}} props
 */
function InformationSection(props) {
    const { validationErrors } = props;
    const dispatch = useDispatch();
    /** @type {ShiftBidding.AdminStore} */
    // @ts-ignore
    const { adminAwardingRule } = useSelector((state) => state);
    const {
        name,
        description,
    } = adminAwardingRule;

    /**
     * @param {string} target
     * @param {string} value
     */
    const updateAwardingRuleStore = (target, value) => {
        dispatch({
            type: UPDATE_AWARDING_RULE,
            payload: {
                [target]: value,
            },
        });
    };

    return (
        <Card className="card">
            <CardHeader
                className="card--header"
                color="textSecondary"
                avatar={<Avatar className="avatar">{1}</Avatar>}
                title="Information"
            />
            <CardContent>
                <div>
                    <InputTitle>Name</InputTitle>
                    <TextField
                        // @ts-ignore
                        error={validationErrors.name}
                        value={name}
                        onChange={(event) => updateAwardingRuleStore('name', event.target.value)}
                        inputProps={{ maxLength: 50 }}
                        placeholder="Name"
                        variant="outlined"
                    />
                    {
                        validationErrors.name ? <span style={{ color: 'red' }}>Name field is required to be unique!</span> : null
                    }
                    <InputDisclaimer>50 characters max.</InputDisclaimer>
                </div>
                <div>
                    <InputTitle>Description</InputTitle>
                    <TextField
                        // @ts-ignore
                        value={description}
                        onChange={(event) => updateAwardingRuleStore('description', event.target.value)}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 250 }}
                        placeholder="Description"
                        variant="outlined"
                    />
                </div>
            </CardContent>
        </Card>

    );
}

export default InformationSection;
